import React from "react";
import { ReactComponent as SearchNotFound } from "../../../assets/icons/searchnotfound.svg";
import { ReactComponent as SearchIcon } from "../../../assets/images/companyIcons/search.svg";

const EmptySearch = ({ searchEmptyText, prompt = false }) => {
  searchEmptyText = prompt && searchEmptyText === "Given token not valid for any token type" ? "Please log in to claim this feature." : searchEmptyText;

  return (
    <>
      <div className="p-20 flex-col flex w-full items-center mt-5 bg-transparent border border-secondary rounded-lg text-left">
        {searchEmptyText === `Search & Select your ${prompt ? "prompt" : "business"}` || searchEmptyText === "Search & Select your Insurer" || searchEmptyText === "Search & Select your Broker" ? <SearchIcon /> : <SearchNotFound />}
        <span>{searchEmptyText ?? (prompt ? "No Prompts matched your search" : "No Business matched your search")}</span>
      </div>
    </>
  );
};

export default EmptySearch;
